import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Safety() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-green-600 to-green-800 text-white py-20 pt-36">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="w-20 h-20 flex items-center justify-center bg-white rounded-full mx-auto mb-6">
            <i className="ri-shield-check-line text-5xl text-green-600"></i>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Safety & Trust</h1>
          <p className="text-xl text-green-100 max-w-3xl mx-auto">
            Your safety and security are our top priorities. Every booking on stashly is protected 
            by comprehensive safety measures and trust features.
          </p>
        </div>
      </section>

      {/* Trust & Safety Overview */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              How We Keep You Safe
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Multiple layers of protection for every booking
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-lg border-2 border-gray-100">
              <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-full mb-6">
                <i className="ri-user-search-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Identity Verification</h3>
              <p className="text-gray-600 mb-6">
                All users must verify their identity before booking or hosting. We check government-issued 
                ID, phone numbers, and email addresses.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Government ID verification</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Phone number confirmation</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Email verification</span>
                </li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg border-2 border-gray-100">
              <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-full mb-6">
                <i className="ri-star-line text-3xl text-green-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Review System</h3>
              <p className="text-gray-600 mb-6">
                Our two-way review system helps build trust. Both hosts and renters can leave reviews 
                after each booking.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Verified reviews only</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Public rating system</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Detailed feedback</span>
                </li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg border-2 border-gray-100">
              <div className="w-16 h-16 flex items-center justify-center bg-purple-100 rounded-full mb-6">
                <i className="ri-message-3-line text-3xl text-purple-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Secure Messaging</h3>
              <p className="text-gray-600 mb-6">
                All communication happens through our secure platform. We monitor messages to prevent 
                fraud and ensure safety.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">In-platform messaging</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Fraud detection</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Privacy protection</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Payment Security */}
      <section className="bg-gray-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Secure Payment Protection
              </h2>
              <p className="text-xl text-gray-600 mb-8">
                Your financial information is protected with bank-level security. We never share your 
                payment details with hosts or renters.
              </p>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0">
                    <i className="ri-lock-line text-2xl text-green-600"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">256-bit SSL Encryption</h3>
                    <p className="text-gray-600">All transactions are encrypted with the same technology used by major banks</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full flex-shrink-0">
                    <i className="ri-shield-check-line text-2xl text-blue-600"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">PCI DSS Compliant</h3>
                    <p className="text-gray-600">We meet the highest standards for payment card security</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-full flex-shrink-0">
                    <i className="ri-refund-2-line text-2xl text-purple-600"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Secure Refund Process</h3>
                    <p className="text-gray-600">Eligible refunds are processed quickly and securely back to your original payment method</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20Australian%20person%20making%20secure%20online%20payment%20on%20laptop%20with%20security%20shield%20icons%20and%20lock%20symbols%20visible%20on%20screen%2C%20modern%20home%20office%20setting%2C%20bright%20natural%20lighting%2C%20trust%20and%20security%20theme%2C%20clean%20professional%20atmosphere&width=600&height=700&seq=safety1&orientation=portrait"
                alt="Secure Payment"
                className="w-full h-auto rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Safety Tips */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Safety Tips for Hosts & Renters
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Follow these best practices to ensure a safe and positive experience
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <i className="ri-home-smile-line text-3xl text-blue-600"></i>
                For Hosts
              </h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Screen renters by checking their profiles and reviews before accepting bookings</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Set clear house rules and communicate expectations upfront</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Document the condition of your space with photos before and after each rental</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Keep all communication on the stashly platform</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Report any suspicious activity or policy violations immediately</span>
                </li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <i className="ri-user-smile-line text-3xl text-green-600"></i>
                For Renters
              </h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Read the listing description and reviews carefully before booking</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Communicate with the host about access details and any special requirements</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Inspect the space upon arrival and report any issues immediately</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Respect the host's property and follow all house rules</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-green-600 mt-1"></i>
                  <span className="text-gray-700">Never make payments outside the stashly platform</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 24/7 Support */}
      <section className="bg-gray-50 py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="w-20 h-20 flex items-center justify-center bg-blue-100 rounded-full mx-auto mb-6">
            <i className="ri-customer-service-2-line text-4xl text-blue-600"></i>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            24/7 Customer Support
          </h2>
          <p className="text-xl text-gray-600 mb-10">
            Our dedicated safety and support team is available around the clock to help with any 
            concerns or emergencies. We're here to ensure every booking is safe and successful.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="px-8 py-4 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Contact Support
            </a>
            <a
              href="/how-it-works"
              className="px-8 py-4 bg-white text-blue-600 font-semibold rounded-lg border-2 border-blue-600 hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              Learn More
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
